import React from 'react';
import { BsCheckLg } from 'react-icons/bs';
import { NpsTelaCheia } from '../nps-tela';
import { CheckCirculoStyled, LogoPequenoStyled, RodapeObrigadoStyled, TextoObrigadoStyled, TituloObrigadoStyled, } from './nps-obrigado.component.style';
// Tela 3: encerramento na cor da empresa.
export var NpsObrigado = function (_a) {
    var primeiroNome = _a.primeiroNome, texto = _a.texto, logo = _a.logo, empresa = _a.empresa;
    return (React.createElement(NpsTelaCheia, { alinhamentoTopo: "160px", 
        // p09: círculo menor que o da 2a, com o centro cerca de 10 px para dentro da borda direita.
        circuloSuperior: { diametro: 360, esquerda: 'calc(100% - 10px)' }, circuloInferior: { diametro: 260, topo: '100%' } },
        React.createElement(CheckCirculoStyled, { "aria-hidden": "true" },
            React.createElement(BsCheckLg, { size: 44 })),
        React.createElement(TituloObrigadoStyled, null, primeiroNome ? "Obrigado, " + primeiroNome + "!" : 'Obrigado!'),
        React.createElement(TextoObrigadoStyled, null, texto),
        React.createElement(RodapeObrigadoStyled, null,
            React.createElement(LogoPequenoStyled, { "aria-hidden": "true" }, logo ? React.createElement("img", { src: logo, alt: "" }) : (empresa !== null && empresa !== void 0 ? empresa : '').charAt(0).toUpperCase()),
            "Juntos por uma experi\u00EAncia melhor.")));
};
